import "core-js/modules/es.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import AppTextField from '@/components/AppTextField.vue';
import AppSelector from '@/components/AppSelector.vue';
import AppLightModal from '@/components/AppLightModal.vue';
import { SnackType } from '@/interfaces/snack';
import { showErrors, showNotification } from '@/utils/snack';
import { utcDateTimeToLocal, utcDateTimeToDate } from '@/utils/dateTime';
import { findSchool, deleteSchool } from './gql';
import AuthFilter from '@/mixins/auth-filter';

var SchoolDialog = /*#__PURE__*/function (_mixins) {
  _inherits(SchoolDialog, _mixins);

  var _super = _createSuper(SchoolDialog);

  function SchoolDialog() {
    var _this;

    _classCallCheck(this, SchoolDialog);

    _this = _super.apply(this, arguments);
    _this.schoolsLoading = true;
    _this.targetSchool = null;
    _this.deleteDialog = {
      show: false,
      title: '删除学校',
      text: ''
    };
    _this.utcDateTimeToLocal = utcDateTimeToLocal;
    _this.utcDateTimeToDate = utcDateTimeToDate;
    return _this;
  }

  _createClass(SchoolDialog, [{
    key: "mounted",
    value: function mounted() {
      this.getAttachDealers();
    }
  }, {
    key: "addSchool",
    value: function addSchool() {
      this.$router.push({
        name: 'EditSchool',
        params: {
          type: 'new'
        }
      });
    }
  }, {
    key: "editSchool",
    value: function editSchool(item, type) {
      this.$router.push({
        name: 'EditSchool',
        params: {
          type: type,
          id: item.id,
          name: item.name
        }
      });
    }
  }, {
    key: "deleteHandler",
    value: function deleteHandler(school) {
      this.targetSchool = school;
      this.deleteDialog.text = "\u662F\u5426\u786E\u5B9A\u5220\u9664\u5B66\u6821 \u201C".concat(school.name, "\u201D ?");
      this.deleteDialog.show = true;
    }
  }, {
    key: "getAttachDealers",
    value: function () {
      var _getAttachDealers = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var typedError;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                try {} catch (error) {
                  typedError = error;
                  showErrors(typedError.graphQLErrors);
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getAttachDealers() {
        return _getAttachDealers.apply(this, arguments);
      }

      return getAttachDealers;
    }()
  }, {
    key: "deleteSchoolById",
    value: function () {
      var _deleteSchoolById = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var id, result, typedError;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.targetSchool) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                id = this.targetSchool.id;
                this.deleteDialog.show = false;
                _context2.prev = 4;
                _context2.next = 7;
                return this.$apollo.mutate({
                  mutation: deleteSchool,
                  variables: {
                    schoolId: id
                  }
                });

              case 7:
                result = _context2.sent;

                if (result) {
                  showNotification({
                    msg: '删除成功!',
                    type: SnackType.Success
                  });
                }

                _context2.next = 15;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](4);
                typedError = _context2.t0;
                showErrors(typedError.graphQLErrors);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 11]]);
      }));

      function deleteSchoolById() {
        return _deleteSchoolById.apply(this, arguments);
      }

      return deleteSchoolById;
    }()
  }, {
    key: "getSchoolById",
    value: function () {
      var _getSchoolById = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(schoolId) {
        var result, typedError;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.$apollo.query({
                  query: findSchool,
                  variables: {
                    schoolId: schoolId
                  }
                });

              case 3:
                result = _context3.sent;
                return _context3.abrupt("return", result.data.findSchool);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);
                typedError = _context3.t0;
                showErrors(typedError.graphQLErrors);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function getSchoolById(_x) {
        return _getSchoolById.apply(this, arguments);
      }

      return getSchoolById;
    }()
  }]);

  return SchoolDialog;
}(mixins(AuthFilter));

SchoolDialog = __decorate([Component({
  components: {
    AppTextField: AppTextField,
    AppSelector: AppSelector,
    AppLightModal: AppLightModal
  }
})], SchoolDialog);
export default SchoolDialog;